export default "__VITE_ASSET__dbd8b7df__"